export const TRANSLATION_SECTIONS = {
  "Home": [
    "TOTAL DELIVERY",
    "Total EXPENSE",
    "TOTAL LOCAL",
    "TOTAL ORDER",
    "Total Purchase",
    "TOTAL SALES",
    "TOTAL TAKEAWAY",
  ],
  "Dashboard": [
    "Count",
    "Current Stock",
    "Ingredient Name",
    "Ingredients in Alert",
    "Item Name",
    "Mahali cash/Take Away/Delivery(This Month)",
    "Monthly Sale Comparison",
    "Most Sale Items This Month",
    "Operational Comparision(This Month)",
    "Quick link",
    "Users",
  ],
  "Settings": [
    "Aqua Blue",
    "Auto",
    "Background Color",
    "Background Text Color",
    "Borders Color",
    "Both",
    "Business Emails",
    "Button Color",
    "Button Text Color",
    "Categories Button Color",
    "Category wise",
    "Check Ingredients Stock",
    "Cherry Red",
    "Close Register Password",
    "Dark Green",
    "Default",
    "Enter password",
    "Headings Color",
    "Hours",
    "Invoice",
    "Invoice 1",
    "Invoice 2",
    "Invoice 3",
    "Invoice 3 with Tax",
    "Invoice 3 with VAT",
    "Invoice 4",
    "Invoice Footer",
    "Invoice Footer1",
    "Invoice Footer2",
    "Invoice Item Name",
    "Invoice Language",
    "Item wise",
    "JSPM Print",
    "Let Category Decide",
    "Light Gray",
    "Light Pink",
    "Loader",
    "Manual",
    "Mobile Application Theme Color",
    "No of Invoices",
    "Popup Buttons Color",
    "Require Password to Close Register (Cashier)",
    "Reset",
    "Reset after 1 day",
    "Reset Order Numbers",
    "Restaurant Name",
    "Restaurant Setting",
    "Round Off",
    "Sale Date & Time",
    "Select Printing Type",
    "Splash Image",
    "Sun Light",
    "Text Color",
    "Theme",
    "Theme 1",
    "Theme 2",
    "Theme Color",
    "Theme Color For Webpage",
    "Theme Design",
    "Use Shift Timing",
    "Whatsapp Number",
    "Zatca Enabled?",
  ],
  "Language": [
    "Key",
  ],
  "Items": [
    "Add",
    "Add Deal",
    "Add Ingredient",
    "Add Ingredient Category",
    "Add Main Category",
    "Add Modifier",
    "Add Sub Category",
    "Add Unit",
    "Alert Qty",
    "Alert Quantity/Amount",
    "Assign Add On",
    "Assign Delivery Company",
    "Assign Food Menu Modifier",
    "Category Name Arabic",
    "Choose Banner",
    "Choose icon",
    "Consumption",
    "Consumption Unit",
    "Enter",
    "Food Menu Details",
    "Ingredient Consumptions",
    "Is it Bar Item?",
    "Is it Beverage?",
    "Is it Veg Item?",
    "Is Tax Fix?",
    "Is Vendor?",
    "Is Weighted",
    "Kot Print",
    "Logo Image",
    "Modifier",
    "New",
    "no tax",
    "Pos Status",
    "Printer Name",
    "Priority (1-10)",
    "Purchase Unit",
    "Purchase Unit Price",
    "Round Down",
    "Sale Price",
    "Select All",
    "Select Category Name",
    "Sub Category",
    "Sub Category Name",
    "Sub Category Name Arabic",
    "Sub Category Name English",
    "Subscription Status",
    "Tax Type (VAT)",
    "Tax Type(VAT)",
    "Total Amount with Vat",
    "Total Ingredients",
    "Unit",
    "Units",
    "Upload Ingredient",
    "Upload Ingredients",
    "Upload Items",
    "Variants",
    "Web Status",
  ],
  "Management": [
    "80mm printer width",
    "Add Delivery Company",
    "Add Return",
    "Add Table",
    "Adjust Inventory",
    "Align",
    "All Return",
    "Approved",
    "Are you sure you want to delete this deposit?",
    "Back To Category",
    "Backend endpoint for invoice templates isn't available yet — templates are being saved in this browser only (localStorage). They'll sync to the server automatically once that endpoint is added.",
    "Bold",
    "Categories",
    "Category Printer",
    "Center",
    "Custom text",
    "Delete All Data",
    "Delete Field",
    "Delivery Company Name",
    "Drag a field onto the invoice canvas",
    "Drag fields here to build the invoice layout",
    "Drag onto the canvas, or double-click to add",
    "Edit Deposit",
    "Edit Invoice Template",
    "Enter return amount",
    "Field Settings",
    "Fields",
    "Font Size",
    "Generate Card",
    "Is Default",
    "Left",
    "New Invoice Template",
    "No payment methods found in the system.",
    "Note: Before assigning products please download client machine to allow RMS to read your system printers. Download Link JSPM Click on three dots menu to assign printers on product level. To assign printers on category level click on category printers button above here all category will display click on three dots to assign printers.",
    "Old Printer Name",
    "Outlet / Branch",
    "Payment Methods Management",
    "Pending",
    "Position",
    "Preview only for now — this is a design/mapping tool. Wiring templates into real printing (JSPM / 80mm silent print) is a separate follow-up step.",
    "Print Invoice",
    "Product Printer",
    "Products",
    "QR Code",
    "Return Amount",
    "Return Deposit",
    "Right",
    "Save",
    "Seat Capacity",
    "Select a field on the canvas to edit it",
    "Select Printer by Category",
    "Select Printer by Product",
    "Table Name",
    "Template Name",
  ],
  "Delivery": [
    "Cancel Order",
    "Cancel Reason",
    "Confirm Cancel",
    "Created At",
    "Distance (km)",
    "Enter cancel reason...",
    "Latitude",
    "Longitude",
    "Remarks",
    "Rider Deliveries",
  ],
  "Outlet": [
    "Add Outlet",
    "All Items",
    "All Modifiers",
    "Copy Items Between Branches",
    "Copy Type",
    "Copying...",
    "In-Active",
    "Outlet Code",
    "Outlet Name",
    "Select Category",
    "Select Source Outlet",
    "Select Target Outlet",
    "Source Outlet",
    "Specific Category",
    "Specific Item",
    "Start Copy",
    "Target Outlet",
  ],
  "Reporting": [
    "Activity",
    "All Sales (Paid Amount)",
    "All Sales(Only Paid Amount)",
    "Attendance Report",
    "Business Overview",
    "Closing Balance",
    "Closing Date & Time",
    "Consumption Report",
    "Cooking End Time",
    "Cooking Start Time",
    "Coupon Code",
    "Coupon Code Report",
    "Customer Due Receive",
    "Customer Due Receives",
    "Customer Due Report",
    "Customer Ledger",
    "Customer Report",
    "Daily Sale Report",
    "Summary Report",
    "Expense Supplier Due",
    "Detailed Purchase Report",
    "Detailed Sale Report",
    "Detailed Shift Report",
    "Discount Amount",
    "Due Payment",
    "Due Receive",
    "Earned Points",
    "End Date & Time",
    "Expense Item",
    "Expense Report",
    "Food Sale Report",
    "Food Sales Report",
    "Gross Profit = ((All Sales + Subscriptions + Customer Due Receive) - (Purchase + Expense + Return + Waste + Supplier Due Payment))",
    "Ingredent",
    "Ingredent in Alert",
    "Ingredient Name(Code)",
    "Inventory Report",
    "Kitchen Performance Report",
    "Low Inventory Report",
    "Loyalty Point Report",
    "Loyalty Points Report",
    "Multiple Vat Report",
    "Net Profit = ((All Sales + Subscriptions + Customer Due Receive) - (Purchase + Expense + Return + Waste + Supplier Due Payment) - Vat))",
    "Opening Balance",
    "Opening Date & Time",
    "Order #",
    "Order status",
    "Order Time",
    "Overall report",
    "Overall Report",
    "Payable Due",
    "Payables and Receivables",
    "Payment Amount",
    "Payment Status",
    "Preview",
    "Product Price",
    "Profit Loss Report",
    "Purchase Report",
    "Purchase(Only Paid Amount)",
    "Purchased By",
    "Receive Amount",
    "Reference",
    "Register Report",
    "Remaining Point",
    "Return Report",
    "Rider Report",
    "Sale",
    "Sales",
    "Spent Points",
    "Start Date & Time",
    "Subscriptions Amount with VAT",
    "Sum",
    "Supplier Due Payment",
    "Supplier Due Payments",
    "Supplier Due Report",
    "Supplier Ledger",
    "Supplier Report",
    "Time Taken (min)",
    "Total Expense",
    "TOTAL EXPENSE",
    "Total Item",
    "TOTAL PURCHASE",
    "Total Return",
    "Total Sale",
    "TOTAL SALE",
    "Total Vat",
    "VAT FORMULA : TOTAL VAT = TOTAL SALE VAT - (PURCHASE VAT + RETURN VAT + EXPENSE VAT)",
    "Vat Name",
    "Vat Report",
    "Vendor report",
    "Waste Report",
  ],
  "All Sales": [
    "Add Sale",
    "App",
    "Date(Time)",
    "Order By",
    "Order From",
    "POS Orders",
    "View Invoice",
    "Web",
    "Web Orders",
  ],
  "E-Commerce": [
    "Add Banner",
    "Add Banner Video",
    "Add Image of size 1890 x578",
    "Add to Cart",
    "Add Top Banner",
    "Add Video",
    "Alternate number",
    "Banner",
    "Bearer Token",
    "Delivery instruction",
    "Download",
    "Driver",
    "Edit Order Type",
    "Edit Top banner",
    "Email Status",
    "Google Map",
    "Host",
    "Image",
    "Link",
    "Mada id",
    "Mailer name",
    "Mastercard id",
    "Message Service Id",
    "Nearest landmark",
    "Order Confirmation Email",
    "Port",
    "Prefix",
    "Product description",
    "Protocol",
    "Qrcode Generator",
    "Server Id",
    "Signup Email",
    "Smtp mail config",
    "Template",
    "Token",
    "Url",
    "Video",
    "Website Language",
  ],
  "Accounting": [
    "charge_type",
    "company",
    "company_id",
    "cost_center",
    "currency",
    "debit_to",
    "ERP Setup",
    "ERP Status",
    "erp_account",
    "expense_account",
    "income_account",
    "is_pos",
    "item_code",
    "Login Api",
    "mode_of_payment",
    "naming_series",
    "paid_status",
    "pos_profile",
    "Post Api",
    "selling_price_list",
    "taxes_and_charges",
    "uom",
    "write_off_account",
    "write_off_cost_center",
  ],
  "Zatca": [
    "Binary Token",
    "Business Category",
    "Clearance",
    "Common Name",
    "Copied to clipboard!",
    "Copy Binary Token",
    "Copy Full CSR",
    "Copy Private Key",
    "Copy Request ID",
    "Copy Secret Key",
    "Credit Note",
    "CSR Content",
    "Debit Note",
    "Failed to copy!",
    "For B2B / standard tax invoices.",
    "For B2C / simplified e-invoices.",
    "Get Production Key",
    "HTTP Status",
    "Not Available",
    "Organization",
    "Organizational Unit",
    "OTP",
    "Private Key",
    "Registered Address",
    "Reporting Status",
    "Request ID",
    "Secret Key",
    "Serial 1",
    "Serial 2",
    "Serial 3",
    "Simplified Credit Note",
    "Simplified Debit Note",
    "Simplified Invoice",
    "Simplified Standard",
    "Standard Invoice",
    "UID",
    "Unknown Invoice",
    "Zatca Configuration",
    "Zatca Environment",
    "Zatca Status",
    "ZATCA Test Invoices",
  ],
  "Promotion": [
    "Add Category Discount",
    "Add Category Schedule",
    "Add Coupon",
    "Add Credit Card",
    "Add Product Discount",
    "Add Subscriptions",
    "Category Schedules",
    "Company Subscriptions",
    "Convert Points",
    "Delivery Amount",
    "Details",
    "Discount Type",
    "Discount(%)",
    "End Time",
    "Expire Days",
    "Expired date",
    "Expired Date",
    "Heading",
    "Is Offer ?",
    "Meal Qty",
    "Meal Type",
    "Minimum Point To Transfer",
    "Minimum Purchase Price",
    "One Time",
    "Package Amount",
    "Package Amount Discount",
    "Percentage Of Loyalty Point On Order Amount",
    "Product Name",
    "Regular",
    "Service/Delivery Charge",
    "Single Use",
    "Specific Customers",
    "Start Time",
    "Subscription",
    "Total meal quantity",
    "Use Discount",
    "VAT Name",
  ],
  "Customer Feedback": [
    "Add Feedback",
    "Answer",
    "Customer Feedbacks",
    "Feedback Details",
    "Feedback from",
    "Feedback Questions",
    "No detailed feedback available",
    "No feedback form found.",
    "Submit Feedback",
    "Type your answer here...",
  ],
  "Feedback": [
    "Add Question",
    "Answer...",
    "Copy Link",
    "Enter feedback form title",
    "Feedback Form",
    "Form Title",
    "Option",
    "Question",
    "Save Feedback",
    "Switch to Answer Mode",
    "Switch to Options Mode",
  ],
  "Purchase": [
    "Add Due Payment",
    "Add Expense Category",
    "Add Expenses",
    "Add Inventory Adjustment",
    "Add Inventory Adjustments",
    "Add Payment",
    "Add Purchases",
    "Consumption Status",
    "Edit Supplier",
    "Expense Category Name",
    "Expense Item Vat i.e (5,10,15 ..)",
    "G.Total",
    "Ingredient in Alert",
    "Invoice Date",
    "Invoice Reference",
    "Invoice Number",
    "Minus",
    "No Tax",
    "Paymeny method",
    "Plus",
    "Purchases",
    "Quick add supplier",
    "SR",
    "Stock Value",
    "Submit Inventory",
    "Total amount with vat",
    "Vat(%)",
  ],
  "Waste": [
    "(Only purchased Ingredients are listed)",
    "Add Waste",
    "Are you sure you want to delete this waste record?",
    "Edit Waste",
    "ENTER....",
    "Food Menu Count",
    "Food Menu Waste Items",
    "Quantity/Code",
    "Quantity/Unit",
    "Select User",
  ],
  "User Section": [
    "Add Company",
    "Add Customer Due Receive",
    "Add Subscription by Customer",
    "Add Supplier",
    "Add Supplier Due Payment",
    "Add Vendor",
    "Add/Update Attendance",
    "Contact Person",
    "Date Of Anniversary",
    "Date Of Birth",
    "Delivery Charges",
    "DOA",
    "For",
    "Is Company Employer",
    "On below categories:",
    "Should contain country code",
    "Subscribe Now",
    "Supplier VAT",
    "Total Meal Quantity",
    "Upload Customer",
    "Vendors",
  ],
  "Role Management": [
    "Accountant",
    "Activate",
    "Add User",
    "Assign Item Category",
    "Camera is off",
    "Capture & Submit",
    "Change Password",
    "Change Profile",
    "Country Time Zone",
    "Currency",
    "Date Format",
    "Deactivate",
    "Designation",
    "Display User",
    "Email Address",
    "Enter Waiter for waiter, to be appeared in waiter dropdown in POS screen",
    "Expiry date (MM/YY)",
    "General Setting",
    "Iqama Number",
    "Menu Access",
    "New Password",
    "Passport Number",
    "Processing...",
    "Product Manager",
    "Resturant Name",
    "Role",
    "Start Camera",
    "Stop Camera",
    "System User",
    "Web User",
  ],
  "Shift Open/Close": [
    "Open Balance",
    "Open Register",
  ],
  "Login": [
    "Demo Login Credentials",
    "Enter your email",
    "Face Login",
    "Welcome back",
    "Welcome back! Please enter your details",
  ],
  "Invoices": [
    "Card Company",
    "Cash",
    "Cashier Name",
    "Certified Amount",
    "Check",
    "Customer Number",
    "Customer Vat",
    "Cutomer Name",
    "Cutomer Number",
    "Input Method",
    "Invoice No",
    "Item Price",
    "Multi Cash",
    "Printed At",
    "Sales Associate",
    "Selling Point",
    "Service/Delivery",
    "Simplified Tax Invoice",
    "Tax",
    "Tax Rate",
    "Terminal",
    "Tobacco Tax 100%",
    "Total Item(s)",
    "Total Paid (Cash)",
    "Welcome",
  ],
  "POS": [
    "Add To Cart",
    "All Category",
    "Amount can not be greater or less than the total amount",
    "Apply",
    "Available",
    "By Default Password is",
    "Companies Name",
    "Coupon Discount",
    "CPanel",
    "Create Invoice & Close",
    "Date of Birth",
    "Deal Items",
    "Decline",
    "Del",
    "Delete all Hold Sales",
    "Delivery Address",
    "Delivery Options",
    "Delivery Orders",
    "Deposits List",
    "Dine-in",
    "Dine-in Orders",
    "Done",
    "Edit in Cart",
    "Edit Order",
    "Employee Information",
    "Employee Name",
    "Hold",
    "Hold Sale",
    "Logout",
    "Multi Payments",
    "No deposits found.",
    "No Modifier for selected item.",
    "No recent orders found",
    "Ord.",
    "Out of stock",
    "Person",
    "Pick-Up",
    "Pickup Time",
    "Place Order",
    "Points Equal To",
    "Proceed Without Table",
    "Redeem Points",
    "Remaining Amount",
    "Remaining Points",
    "Running Orders",
    "Should have country code",
    "Sit Capacity",
    "Started Cooking",
    "Table 1",
    "Table, Order Number, Customer",
    "Takeaway Orders",
    "Total bill amount",
    "Total Bill Amount",
    "Total Pay Amount",
    "Update Order",
    "Variation",
  ],
  "Website": [
    "© 2024 Copyright: Imdady.com",
    "add to cart",
    "addon",
    "Already have an account?",
    "Alternate Number",
    "and",
    "apply",
    "arabic",
    "Assign Add Ons",
    "Available Meal",
    "Back to Signup",
    "branch",
    "cart",
    "cart is empty",
    "Choose Icon",
    "contact",
    "continue to add more",
    "continue to checkout",
    "coupon code",
    "Create an Account",
    "current datetime",
    "default",
    "delivery",
    "delivery address",
    "Delivery Instructions",
    "Didn't receive the code?",
    "dine-in",
    "discount",
    "Employee Card",
    "english",
    "Enter OTP",
    "Enter your number",
    "excluding vat",
    "extra topping",
    "extra vat",
    "featured items",
    "follow us",
    "full name",
    "Hunger Station Price",
    "I accept the",
    "imdady",
    "including vat",
    "Jahiz Price",
    "Login",
    "Mada",
    "Mahali Cash",
    "Master Card",
    "Meal Quantity",
    "mobile number",
    "my account",
    "my cart",
    "Nearest Landmark",
    "new",
    "off",
    "OTP Resent Successfully",
    "OTP Verified Successfully",
    "our menu",
    "our timings",
    "out of stock",
    "Payment - Cash",
    "payment summary",
    "pickup time",
    "place order",
    "please select your location",
    "Privacy Policy",
    "Resend OTP",
    "sar",
    "search",
    "select",
    "select area/branch",
    "select city/region",
    "select table",
    "select your order type",
    "SignUp",
    "Something went wrong",
    "Success",
    "Take away",
    "Take Away",
    "takeaway",
    "Terms of Service",
    "total amount",
    "total meal",
    "use current location",
    "vat",
    "Visa",
    "We have sent a 6-digit verification code to your email.",
    "which outlet would you like to dine-in?",
    "which outlet would you like to pick-up from?",
    "You have reached the maximum allowed quantity for this category in your subscription.",
  ],
  "Common": [
    "Accounting",
    "Action",
    "Actions",
    "Active",
    "Active Status",
    "Add Customer",
    "Add Item",
    "Add Ons",
    "add purchase",
    "Add Purchase",
    "add purchases",
    "Add Subscription",
    "Add VAT",
    "Added By",
    "Address",
    "Alert",
    "Alert Inventory",
    "Alert Qty/Amount",
    "Alert!",
    "All Sales",
    "Amount",
    "Approve",
    "Arabic",
    "Are you sure?",
    "Back",
    "Banner Videos",
    "Banners",
    "Branch",
    "Building Number",
    "Cancel",
    "Cashier",
    "Category",
    "Category Discount",
    "Category Name",
    "Category Schedule",
    "Change Amount",
    "change password",
    "Choose File",
    "City",
    "City Subdivision",
    "Clean Database",
    "Close",
    "Code",
    "Companies",
    "Company Name",
    "Confirm",
    "Confirm Password",
    "Copy Items",
    "Country",
    "Coupon",
    "Credit Card",
    "CSR Setup",
    "Customer",
    "Customer Feedback",
    "Customer Name",
    "Customer Vat No",
    "Customers",
    "Dashboard",
    "Date",
    "Days",
    "Deals",
    "Delete",
    "Delivery",
    "Delivery Companies",
    "Deposit",
    "Description",
    "Direct Invoice",
    "Discount",
    "DOB",
    "Download Sample",
    "Due",
    "Due Amount",
    "E-Commerce",
    "Edit",
    "edit profile",
    "Email",
    "Employee",
    "Employee Card No",
    "End Date",
    "English",
    "Enter the register password to continue.",
    "Enter...",
    "Excel",
    "Exclusive",
    "Expense",
    "Expense Category",
    "Expenses",
    "Expire Date",
    "Expiry Date",
    "Face Registration",
    "Feedback",
    "Finalize Order",
    "Food Menu",
    "G. Total",
    "General Settings",
    "Get Key",
    "Given Amount",
    "Grand Total",
    "home",
    "In Time",
    "Inactive",
    "Inclusive",
    "Incorrect password.",
    "Ingredient",
    "Ingredient (Code)",
    "Ingredient Categories",
    "Ingredient Count",
    "Ingredient Units",
    "Ingredient(Code)",
    "Ingredients",
    "Inventory",
    "Inventory Adjustments",
    "Invoice Builder",
    "Invoice Logs",
    "Item",
    "items",
    "Items",
    "items per page",
    "Kitchen",
    "KOT",
    "language",
    "Language",
    "Loading...",
    "login",
    "Logo",
    "logout",
    "Loss Amount",
    "Loyalty",
    "Loyalty Points",
    "Mail Config",
    "Main Categories",
    "manage user",
    "Management",
    "Name",
    "Name Arabic",
    "No",
    "No data available in table",
    "Note",
    "of",
    "OK",
    "Online Sales",
    "Order",
    "Order Date",
    "Order Details",
    "Order No",
    "Order Number",
    "Order Type",
    "Out Time",
    "Outlet",
    "Outlets",
    "Package Name",
    "pages",
    "Paid",
    "Password",
    "Password Required",
    "Pay Amount",
    "Payment",
    "Payment Gateway",
    "Payment Method",
    "Payment Methods",
    "PDF",
    "Percentage",
    "Phone",
    "pos",
    "POS Sales",
    "Postal Code",
    "Price",
    "Print",
    "Print Date",
    "Print KOT",
    "Printer",
    "Product Discount",
    "Promotion",
    "Purchase",
    "Qrcode",
    "Qty",
    "Qty/Amount",
    "Quantity",
    "Quantity/Amount",
    "Received Amount",
    "Received amount cannot be less than the total amount.",
    "Reference No",
    "Register Details",
    "reload",
    "Remove all prevoius data, before uploading new data.",
    "Renew Production Key",
    "Reporting",
    "Responsible Person",
    "Return",
    "Rider",
    "Rider Order",
    "Role Management",
    "S.R",
    "Save Changes",
    "Screens",
    "Search",
    "Select",
    "Select Item",
    "Select Method",
    "Select Outlet",
    "Service/Delivery Charges",
    "Setting",
    "Setup",
    "shift open close",
    "Sms Module",
    "SN",
    "Social Media",
    "Start Date",
    "Statement Date",
    "Status",
    "Stock Qty/Amount",
    "Street Number",
    "Sub Categories",
    "sub total",
    "Sub Total",
    "Submit",
    "Subscriptions",
    "Subscriptions Management",
    "Subtotal",
    "Supplier",
    "Suppliers",
    "Table",
    "Tables",
    "Tax method",
    "Tax Method",
    "Tax Registration No",
    "Tel",
    "Test Invoice",
    "Text",
    "Time",
    "Time Count",
    "to Not Closed Yet",
    "Top Banner",
    "Total",
    "Total Amount",
    "Total Discount",
    "Total Items",
    "Total Loss",
    "Total Payable",
    "TOTAL RETURN",
    "Total Sales Amount/مجموع المبيعات",
    "Type",
    "Unit Name",
    "Unit Price",
    "Update",
    "Upload File",
    "User",
    "User Management",
    "User Section",
    "Value(Qty)",
    "Vat",
    "VAT",
    "Vat Percentage",
    "VATs",
    "Vendor",
    "Vendor name",
    "Vendor Name",
    "View",
    "View Details",
    "Waiter",
    "Waste",
    "web",
    "Web Setting",
    "Yes",
    "Zatca",
  ],
};

export function getSectionForKey(key) {
  for (const [section, keys] of Object.entries(TRANSLATION_SECTIONS)) {
    if (keys.includes(key)) return section;
  }
  return "Uncategorized";
}

export const SECTION_NAMES = ["All", ...Object.keys(TRANSLATION_SECTIONS), "Uncategorized"];
